import {Injectable} from '@angular/core';
import {doc, Firestore, getDoc} from '@angular/fire/firestore';
import {path_stores_storeId_settings_disable_stock_item_rules} from '../database-paths';
import {IStore} from '../../shared-models/store/store';
import {DisabledRules} from '../../../shared-utilities/models-old/datastructures';

@Injectable({
  providedIn: 'root'
})
export class CollectionOperationalSingularDocumentsService {

  constructor(private firestore: Firestore) {
  }

  async getAutoOrderingStockItemDeletionRules(store: IStore): Promise<DisabledRules> {
    const documentPath = path_stores_storeId_settings_disable_stock_item_rules(store.storeId);
    if (!store?.storeId) {
      return null;
    }
    return new Promise<DisabledRules>(async (resolve, reject): Promise<void> => {
      try {
        const docRef = doc(this.firestore, documentPath);
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot.exists()) {
          const data: DisabledRules = docSnapshot.data() as DisabledRules;
          resolve(data);
        } else {
          resolve(null);
        }
      } catch (error) {
        error.message = `Error getting Operational Document: Shared/Store/Deletion_Rules.\n${error.message}`;
        reject(error);
      }
    });
  }

}
